export const assetsPath = 'assets/';
export const imagesPath = `${assetsPath}images/`;
export const suppliersPath = `${imagesPath}suppliers/`;
